import React from 'react';
import { IntlProvider } from 'react-intl';
import { Language } from '../../utils/languageUtils';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRouter } from '../../router/AppRouter';
import { PendingTakeoverProvider } from '../../contexts/PendingTakeoverContext';


export const App = () => {
    return (
        <IntlProvider locale={Language.getCurrentLanguage()} messages={{}}>
            <Router>
                <PendingTakeoverProvider>
                    <AppRouter />
                </PendingTakeoverProvider>
            </Router>
        </IntlProvider>
    );
};
